<template #default>
  <div class="bond-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit ' + localForm.assetClass : 'Add Bond'"
      :style="{ top: '32px', width: '1500px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="addFormRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-row :gutter="24">
          <a-card
            title="Issuance Details"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  label="Issuer"
                  name="issuer"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-select
                    v-model:value="localForm.issuer.issuerId"
                    @change="onIssuerChange"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in issuerList"
                      :key="item.name"
                      :value="item.issuerId"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="5">
                <a-form-item
                  label="Domicile"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.countryOfDomicile"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item
                  label="Risk"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.countryOfRisk"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="14">
                <a-form-item
                  label="Industry"
                  :labelCol="{ span: 2, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 22 }"
                >
                  <a-input
                    v-model:value="localForm.issuer.gicsSubIndustry"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="24">
              <a-col :span="5">
                <a-form-item
                  label="Inst Class"
                  name="instrumentClass"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.instrumentClass"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    :disabled="isEdit"
                  >
                    <a-select-option
                      v-for="item in bondInstClassList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Name"
                  name="desc"
                  :labelCol="{ span: 3, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 21 }"
                >
                  <a-input v-model:value="localForm.desc" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="BB_TCM"
                  name="ticker"
                  :labelCol="{ span: 4, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 20 }"
                >
                  <a-input
                    v-model:value="localForm.ticker"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item
                  label="ISIN"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input v-model:value="localForm.isin" :disabled="isEdit" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="IssueType"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input v-model:value="localForm.issueType" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="IssueDate"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-date-picker
                    v-model:value="localForm.issueDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Issue Ccy"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input v-model:value="localForm.issueCurrency" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Par Value"
                  name="parValue"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number
                    v-model:value="localForm.parValue"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Issue Price"
                  name="issuePrice"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number
                    v-model:value="localForm.issuePrice"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="PnL Ccy"
                  name="pnlCurrency"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-select
                    v-model:value="localForm.pnlCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item
                  label="Orig Issue Amt"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Amt Curr In Issue"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  label="Max Issue Amt"
                  :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 18 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="Effective From"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Effective To"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Sec Type"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <SecTypeInput v-model:value="localForm.securityType" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card
            title="Security Details"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item
                  label="SecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.securityId"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="ExternalSecurityId"
                  v-if="isEdit"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input
                    v-model:value="localForm.externalSecurityId"
                    :disabled="isEdit"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="12">
              <a-col :span="12">
                <a-form-item
                  label="Exchange"
                  name="exchange"
                  :labelCol="{ span: 5, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 19 }"
                >
                  <a-select
                    v-model:value="localForm.exchange.exchangeId"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in exchangeList"
                      :key="item.exchName"
                      :value="item.exchangeId"
                    >
                      {{ item.exchName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Price Divisor"
                  name="priceDivisor"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceDivisor"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Price Multiplier"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.priceMultiplier"
                    style="width: 100%"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Price Basis"
                  name="cleanDirtyPriced"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.cleanDirtyPriced"
                    style="width: 100%"
                  >
                    <a-select-option value="C">Clean Price</a-select-option>
                    <a-select-option value="D">Dirty Price</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Round Lot Size"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number
                    v-model:value="localForm.lotSize"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Pricing Market"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Primary Market"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option value="P">P</a-select-option>
                    <a-select-option value="N">N</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="List Date"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    v-model:value="localForm.ipoDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Launch Date"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="FAS 157 valuation"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Redemption Ccy"
                  name="redemptionCurrency"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.redemptionCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="Redeem Price" name="redemptionPrice">
                  <a-input-number
                    v-model:value="localForm.redemptionPrice"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="Maturity Date" name="maturityDate">
                  <a-date-picker
                    v-model:value="localForm.maturityDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Is 144"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.isRule144"
                    style="width: 100%"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <!-- <a-select-option value="R">R</a-select-option> -->
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Is RegS"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    style="width: 100%"
                    v-model:value="localForm.isRegS"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <!-- <a-select-option value="R">R</a-select-option> -->
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="Series">
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Market Listing Type"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select style="width: 100%" disabled>
                    <a-select-option value="A">A Shares-China</a-select-option>
                    <a-select-option value="B">B Shares-China</a-select-option>
                    <a-select-option value="'*'">All</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Coupon Ccy"
                  name="couponCurrency"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.couponCurrency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    :disabled="
                      isEdit && !isEmptyValue(localForm.couponCurrency)
                    "
                  >
                    <a-select-option
                      v-for="item in currencyList"
                      :key="item.currencyCode"
                      :value="item.currencyCode"
                    >
                      {{ item.currencyCode }} - {{ item.currencyDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Cpon/PnL Ccy Xrate"
                  name="fixedRate"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-row>
                    <a-col :span="12">
                      <a-input-number
                        v-model:value="localForm.fixedRate"
                        style="width: 100%"
                        :disabled="
                          isEdit &&
                          !isEmptyValue(localForm.fixedRate) &&
                          !isEmptyValue(localForm.fixedRateMdInd)
                        "
                      />
                    </a-col>
                    <a-col :span="12">
                      <a-select
                        style="width: 100%"
                        v-model:value="localForm.fixedRateMdInd"
                        :disabled="
                          isEdit &&
                          !isEmptyValue(localForm.fixedRate) &&
                          !isEmptyValue(localForm.fixedRateMdInd)
                        "
                      >
                        <a-select-option value="M">M</a-select-option>
                        <a-select-option value="D">D</a-select-option>
                      </a-select>
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="Status">
                  <a-select
                    v-model:value="localForm.isActive"
                    style="width: 100%"
                  >
                    <a-select-option :value="true">ACTIVE</a-select-option>
                    <a-select-option :value="false">INACTIVE</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="External Type"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card
            title="Coupon & Yield Details"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Accrual Date"
                  name="accrualDate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    v-model:value="localForm.accrualDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Accrual Type"
                  name="accrualType"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.accrualType"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in ACCRUALTYPE_LIST"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Calendar Roll Type"
                  name="calendarRollType"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.calendarRollType"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in calendarRollTypeList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Calendar Roll Ctry"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.calendarRollCountry"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in countryList"
                      :key="item.countryDesc"
                      :value="item.countryCode"
                    >
                      {{ item.countryDesc }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="First Coupon Date"
                  name="firstCouponDate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    v-model:value="localForm.firstCouponDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="First Coupon Rate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-row>
                    <a-col :span="23">
                      <a-input-number
                        v-model:value="localForm.firstCouponRate"
                        style="width: 100%"
                      />
                    </a-col>
                    <a-col :span="1" style="width: 100%">%</a-col>
                  </a-row>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Fixed/Variable Cpon"
                  name="fixedVariableCoupon"
                  :labelCol="{ span: 11, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 13 }"
                >
                  <a-select
                    v-model:value="localForm.fixedVariableCoupon"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in fixedVariableCouponList"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Coupon Rate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-row>
                    <a-col :span="23">
                      <a-input-number
                        v-model:value="localForm.couponRate"
                        style="width: 100%"
                      />
                    </a-col>
                    <a-col :span="1" style="width: 100%">%</a-col>
                  </a-row>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Coupon Pay Frequency"
                  name="couponPaymentFrequency"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    v-model:value="localForm.couponPaymentFrequency"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in couponPaymentFrequencyList"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Pay Date Offset"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number
                    v-model:value="localForm.payDateOffset"
                    style="width: 100%"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Pay Date Payment Convention"
                  name="payDatePaymentConvention"
                  :labelCol="{ span: 15, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 9 }"
                >
                  <a-select
                    v-model:value="localForm.payDatePaymentConvention"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in payDatePaymentConventionList"
                      :key="item.key"
                      :value="item.value"
                    >
                      {{ item.key }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Capitalisation Schedule"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="N">N</a-select-option>
                    <a-select-option value="Y">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Period Coupon Adjusted Ind"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="Adjusted">Adjusted</a-select-option>
                    <a-select-option value="Unadjusted"
                      >Unadjusted</a-select-option
                    >
                    <a-select-option value="NotApplicable"
                      >Not Applicable</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Default"
                  name="isInDefault"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    v-model:value="localForm.isInDefault"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Default Date"
                  name="defaultDate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    v-model:value="localForm.defaultDate"
                    style="width: 100%"
                    format="YYYY-MM-DD"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="localForm.instrumentClass === 'FRN'">
              <a-col :span="6">
                <a-form-item
                  label="Cap Rate"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Floor Rate "
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row
              :gutter="24"
              v-if="
                localForm.instrumentClass === 'CONVBND' ||
                localForm.instrumentClass === 'FRN'
              "
            >
              <a-col :span="6">
                <a-form-item
                  label="Coupon Reset Freq"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in couponResetFrequencyList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Spread Basis"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option
                      v-for="item in spreadBasisTypeList"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Put Notice Days"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Call Notice Days"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Min Call Amt"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item
                  label="Guarantor"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="Guarantee Type"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-input-number style="width: 100%" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="First Settlement Date"
                  :labelCol="{ span: 10, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 14 }"
                >
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>
        <a-row :gutter="24">
          <a-card
            title="Others"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <a-row :gutter="24">
              <a-col :span="4">
                <a-form-item
                  label="Callable"
                  name="isCallable"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.isCallable"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Puttable"
                  name="isPuttable"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    v-model:value="localForm.isPuttable"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Sinking Fund"
                  name="isSinkingFund"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    v-model:value="localForm.isSinkingFund"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Fungible Ind"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    v-model:value="localForm.isFungible"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Instrument Status"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="false">N</a-select-option>
                    <a-select-option value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Trace Eligib"
                  :labelCol="{ span: 11, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 13 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="false">N</a-select-option>
                    <a-select-option value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="4">
                <a-form-item
                  label="Serial Redeem"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="false">N</a-select-option>
                    <a-select-option value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Perpetual"
                  :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 16 }"
                >
                  <a-select
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                    disabled
                  >
                    <a-select-option value="false">N</a-select-option>
                    <a-select-option value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Partly Paid"
                  name="isPartlyPaid"
                  :labelCol="{ span: 12, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 12 }"
                >
                  <a-select
                    v-model:value="localForm.isPartlyPaid"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Warrants Attached"
                  name="hasWarrantsAttached"
                  :labelCol="{ span: 15, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 9 }"
                >
                  <a-select
                    v-model:value="localForm.hasWarrantsAttached"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="4">
                <a-form-item
                  label="Convertible Ind"
                  name="isConvertible"
                  :labelCol="{ span: 14, style: { textAlign: 'left' } }"
                  :wrapperCol="{ span: 10 }"
                >
                  <a-select
                    v-model:value="localForm.isConvertible"
                    allow-clear
                    :show-search="true"
                    :filter-option="filterOption"
                  >
                    <a-select-option :value="false">N</a-select-option>
                    <a-select-option :value="true">Y</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-row>
        <a-row :gutter="24">
          <a-card
            v-if="localForm.instrumentClass === 'CONVBND'"
            title="Conversion Terms"
            :bordered="true"
            style="width: 100%; margin: 6px"
          >
            <div style="margin: 0px; height: 100px">
              <AgGridVue
                style="width: 100%; height: 100%"
                :theme="themeBalham"
                :columnDefs="conversionTermsColumnDefs"
                :rowData="rowData"
              />
            </div>
          </a-card>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  defineProps,
  defineEmits,
  inject,
  // watchEffect,
  watch,
} from 'vue'
import { useStore } from 'vuex'
import SecTypeInput from '@/components/SecTypeInput.vue'
// import debounce from 'lodash/debounce'
import { message } from 'ant-design-vue'
import { themeBalham } from 'ag-grid-community'
import dayjs from 'dayjs'
import { ACCRUALTYPE_LIST } from '@/utils/secutils'

const store = useStore()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  addForm: {
    type: Object,
    required: true,
  },
})

const labelCol = {
  span: 8,
  style: { textAlign: 'left' },
}

const wrapperCol = {
  span: 18,
}

const calendarRollTypeList = ref([
  'BUS',
  'ME',
  'ME_RB',
  'NLME',
  'NONE',
  'NONE_BUS',
  'RB',
  'RF',
  'RFWM',
])

const couponResetFrequencyList = ref([
  'Half Yearly',
  'Quarterly',
  'Monthly',
  'Daily',
])

const spreadBasisTypeList = ref([
  'CD_RATE',
  'EURIBOR',
  'HIBOR',
  'LIBID',
  'LIBOR',
  'PIBID',
  'PIBOR',
  'REPO_RATE',
  'SIBOR',
  'SOR',
  'UNKNOWN',
])

const fixedVariableCouponList = ref([
  { key: 'Fixed', value: 'F' },
  { key: 'Variable', value: 'V' },
])

const couponPaymentFrequencyList = ref([
  { key: 'Annual(28D/13M)', value: '1.28' },
  { key: 'Semi-Annual(28D/6M)', value: '2.28' },
  { key: 'Quarterly(28D/3M)', value: '4.28' },
  { key: 'Monthly(28D/1M)', value: '13.28' },
  { key: 'None', value: '-126' },
  { key: 'Irregular', value: '-42' },
  { key: 'Overnight', value: '365' },
  { key: 'Weekly', value: '52' },
  { key: 'Monthly', value: '12' },
  { key: '2 Monthly', value: '6' },
  { key: 'Quarterly', value: '4' },
  { key: '4 Monthly', value: '3' },
  { key: 'Semi-Annual', value: '2' },
  { key: 'Annual', value: '1' },
  { key: 'Biennial', value: '0.5' },
  { key: 'Continuously compounded', value: '0' },
])

const payDatePaymentConventionList = ref([
  { key: 'Business Date', value: 'BUS' },
  { key: 'EOM', value: 'ME' },
  { key: 'EOM_RB', value: 'ME_RB' },
  { key: 'EOM - Non Leap', value: 'NLME' },
  { key: 'No Roll', value: 'NONE' },
  { key: 'None - Business Date', value: 'ONE_BUS' },
  { key: 'Proceding', value: 'RB' },
  { key: 'Following', value: 'RF' },
  { key: 'Modified Following', value: 'RFWM' },
])

const conversionTermsColumnDefs = [
  { headerName: 'Underlying', field: 'underlyingTicker', flex: 1 },
  { headerName: 'Option Num', field: 'optionNum', flex: 1 },
  { headerName: 'Shares Per Bond', field: 'sharesPerBond', flex: 1 },
  { headerName: 'Min Conv Amt', field: 'minConvAmt', flex: 1 },
  { headerName: 'Conversion Price', field: 'conversionPrice', flex: 1 },
  { headerName: 'Conv Price Ccy', field: 'convPriceCcy', flex: 1 },
  { headerName: 'Fixed Xrate', field: 'fixedXrate', flex: 1 },
  { headerName: 'Exercise Text', field: 'exerciseText', flex: 1 },
]
const rowData = ref([])

const exchangeList = inject('exchangeList', ref([]))
const issuerList = inject('issuerList', ref([]))
const bondInstClassList = inject('bondInstClassList', ref([]))
const security = inject('security')

const addFormRef = ref()
const loading = ref(false)
const localForm = ref(props.addForm)

// set only when the user picks an issuer from the dropdown, so the currency
// defaults below never overwrite values loaded from getSecurity
const isIssuerSelectedByUser = ref(false)
const onIssuerChange = () => {
  isIssuerSelectedByUser.value = true
}
const rules = ref({
  instrumentClass: [
    { required: true, message: 'Please input instrumentClass' },
  ],
  desc: [{ required: true, message: 'Please input name' }],
  ticker: [{ required: true, message: 'Please input BB_TCM' }],
  issuer: [{ required: true, message: 'Please select issuer' }],
  parValue: [{ required: true, message: 'Please input par value' }],
  // issuePrice: [{ required: true, message: 'Please input issue price' }],
  pnlCurrency: [{ required: true, message: 'Please select PnL ccy' }],
  exchange: [{ required: true, message: 'Please select exchange' }],
  priceDivisor: [{ required: true, message: 'Please input price divisor' }],
  cleanDirtyPriced: [{ required: true, message: 'Please select price basis' }],
  // redemptionCurrency: [
  //   { required: true, message: 'Please select redemption ccy' },
  // ],
  // redemptionPrice: [
  //   { required: true, message: 'Please input redemption price' },
  // ],
  maturityDate: [{ required: true, message: 'Please input maturity date' }],
  // couponCurrency: [{ required: true, message: 'Please select coupon ccy' }],
  // fixedRate: [{ required: true, message: 'Please input fixed rate' }],
  // accrualDate: [{ required: true, message: 'Please input accrual date' }],
  // accrualType: [{ required: true, message: 'Please select accrual type' }],
  // calendarRollType: [
  //   { required: true, message: 'Please select calendar roll type' },
  // ],
  firstCouponDate: [
    { required: true, message: 'Please input first coupon date' },
  ],
  // fixedVariableCoupon: [
  //   { required: true, message: 'Please select fixed/variable coupon' },
  // ],
  // couponPaymentFrequency: [
  //   { required: true, message: 'Please select coupon payment frequency' },
  // ],
  payDatePaymentConvention: [
    { required: true, message: 'Please select pay date payment convention' },
  ],
  isInDefault: [{ required: true, message: 'Please select default' }],
  // isCallable: [{ required: true, message: 'Please select callable' }],
  // isPuttable: [{ required: true, message: 'Please select puttable' }],
  // isSinkingFund: [{ required: true, message: 'Please select sinking fund' }],
  // isPartlyPaid: [{ required: true, message: 'Please select partly paid' }],
  // hasWarrantsAttached: [
  //   { required: true, message: 'Please select warrants attached' },
  // ],
  isConvertible: [{ required: true, message: 'Please select convertible' }],
})

const countryList = computed(() => {
  const countries = store.getters['reference/getCountryList'] || []
  return [...countries].sort((a, b) =>
    a.countryCode.localeCompare(b.countryCode)
  )
})

const currencyList = computed(() => {
  const currencies = store.getters['reference/getCurrencyList'] || []
  return [...currencies].sort((a, b) =>
    a.currencyCode.localeCompare(b.currencyCode)
  )
})

const countryCurrencyList = computed(() => {
  return store.getters['reference/getCountryCurrencyList'] || []
})

const emit = defineEmits(['update:visible', 'update:security'])

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const userName = computed(() => store.getters['auth/getUserName'] || 'Guest')
const booleanFields = [
  'isRule144',
  'isRegS',
  'isActive',
  'isInDefault',
  'isCallable',
  'isPuttable',
  'isSinkingFund',
  'isFungible',
  'isPartlyPaid',
  'hasWarrantsAttached',
  'isConvertible',
]
const normalizeBooleanValue = (value) => {
  if (value === 'true' || value === 'True') return true
  if (value === 'false' || value === 'False') return false
  return value
}
const isEmptyValue = (value) =>
  value === null || value === undefined || value === ''

watch(
  () => props.addForm,
  (newVal) => {
    isIssuerSelectedByUser.value = false
    if (props.visible) {
      localForm.value = newVal
      for (const field of booleanFields) {
        if (Object.prototype.hasOwnProperty.call(localForm.value, field)) {
          localForm.value[field] = normalizeBooleanValue(localForm.value[field])
        }
      }
      if (props.isEdit) {
        rowData.value = []
        const row = {
          underlyingTicker: localForm.value.underlyingTicker,
          optionNum: localForm.value.optionNum,
          sharesPerBond: localForm.value.conversionRatio,
          minConvAmt: localForm.value.minConvAmt,
          conversionPrice: localForm.value.conversionPrice,
          convPriceCcy: localForm.value.convPriceCcy,
          fixedXrate: localForm.value.fixedXrate,
          exerciseText: localForm.value.exerciseText,
        }
        rowData.value.push(row)
      }
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => localForm.value.priceDivisor,
  (newValue) => {
    if (newValue && props.visible) {
      localForm.value.priceDivisor = newValue
      localForm.value.priceMultiplier = 1 / newValue
    }
  },
  { immediate: true }
)

watch(
  () => localForm.value.issuer?.issuerId,
  (newValue) => {
    if (newValue && props.visible) {
      const selectedIssuer = issuerList.value.find(
        (item) => item.issuerId === newValue
      )
      if (selectedIssuer) {
        localForm.value.issuer = {
          issuerId: selectedIssuer.issuerId,
          externalIssuerId: selectedIssuer.externalIssuerId,
          name: selectedIssuer.name,
          countryOfDomicile: selectedIssuer.countryOfDomicile,
        }
        const selectedCurrency = countryCurrencyList.value.find(
          (item) => item.countryCode === selectedIssuer.countryOfDomicile
        )
        if (selectedCurrency && isIssuerSelectedByUser.value) {
          localForm.value.issueCurrency = selectedCurrency.currencyCode
          localForm.value.pnlCurrency = selectedCurrency.currencyCode
          localForm.value.dividendCurrency = selectedCurrency.currencyCode
        }
      }
    }
  },
  { immediate: true }
)

const filterOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const handleOk = () => {
  addFormRef.value
    .validate()
    .then(() => {
      const formatDateTime = (val) =>
        val ? dayjs(val).format('YYYY-MM-DDTHH:mm:ss') : null

      const lastModifiedOn = dayjs(new Date()).format('YYYY-MM-DDTHH:mm:ss')
      const lastModifiedBy = userName.value

      let payload = {
        ...localForm.value,
        name: localForm.value.desc,
        exchange: { ...localForm.value.exchange },
        issuer: { ...localForm.value.issuer },
        identifiers: [],
        underlying:
          localForm.value.underlyingTicker && localForm.value.underlying
            ? { ...localForm.value.underlying }
            : null,
        issueDate: formatDateTime(localForm.value.issueDate),
        maturityDate: formatDateTime(localForm.value.maturityDate),
        settleDate: formatDateTime(localForm.value.settleDate),
        defaultDate: formatDateTime(localForm.value.defaultDate),
        lastModifiedOn: lastModifiedOn,
        lastModifiedBy: lastModifiedBy,
      }

      if (payload.ticker) {
        payload.identifiers.push({
          type: 'BB_TCM',
          value: payload.ticker,
        })
      }
      if (payload.isin) {
        payload.identifiers.push({
          type: 'ISIN',
          value: payload.isin,
        })
      }
      const selectedExchange = exchangeList.value.find(
        (item) => item.exchangeId === payload.exchange.exchangeId
      )
      if (selectedExchange) {
        payload.exchange = {
          exchangeId: selectedExchange.exchangeId,
          exchName: selectedExchange.exchName,
          micExchName: selectedExchange.micExchName,
        }
      }

      const underlyingIdentifiers = []
      if (payload.underlyingTicker) {
        underlyingIdentifiers.push({
          type: 'BB_TCM',
          value: payload.underlyingTicker,
          securityId: payload.underlying.securityId,
          pnlCurrency: payload.underlying.pnlCurrency,
        })
        if (!payload.underlying) payload.underlying = {}
        payload.underlying.identifiers = underlyingIdentifiers
        payload.underlying.instrumentClass = 'DUMMY'
      }

      loading.value = true
      if (props.isEdit) {
        security
          .updateSec(payload)
          .then(() => {
            message.success('Security updated successfully')
            modalVisible.value = false
          })
          .catch((error) => {
            message.error(
              error.response.data.message || 'Failed to update security'
            )
          })
          .finally(() => {
            loading.value = false
          })
      } else {
        security
          .createSec(payload)
          .then(() => {
            message.success('Security created successfully')
            modalVisible.value = false
          })
          .catch((error) => {
            message.error(
              error.response.data.message || 'Failed to create security'
            )
          })
          .finally(() => {
            loading.value = false
          })
      }
    })
    .catch((error) => {
      console.log('error', error)
    })
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>

<style scoped>
.bond-modal :deep(.ant-card) {
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
}
.bond-modal :deep(.ant-card-head-title) {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.bond-modal :deep(.ant-card-body) {
  padding-top: 8px;
}
</style>
